import request from '@/request/request'

/**
 * 新建企业信息
 * @param {} parameter 
 * @returns 
 */
export function createCompany (parameter) {
  return request({
    url: '/e-find-company/company/createCompany',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取绑定企业清单
 * @param {} parameter 
 * @returns 
 */
export function listBindCompany (skipSync = false) {
  return request({
    url: '/e-find-company/company/listBindCompany',
    method: 'get',
    params: { skipSync }
  })
}

/**
 * 强制同步一次主平台企业认证记录
 */
export function syncEnterpriseAuthRecords () {
  return request({
    url: '/e-find-company/company/syncEnterpriseAuthRecords',
    method: 'post'
  })
}

/**
 * 强制同步当前企业的主平台认证记录
 */
export function syncCurrentEnterpriseAuthRecords () {
  return request({
    url: '/e-find-company/company/syncCurrentEnterpriseAuthRecords',
    method: 'post'
  })
}

/**
 * 获取绑定企业清单
 * @param {} parameter 
 * @returns 
 */
export function getCompanyDetail (skipSync = false) {
  return request({
    url: '/e-find-company/company/getCompanyDetail',
    method: 'get',
    params: { skipSync }
  })
}

/**
 * 更新企业信息
 * @param {} parameter 
 * @returns 
 */
export function updateCompany (parameter) {
  return request({
    url: '/e-find-company/company/updateCompany',
    method: 'post',
    data: parameter
  })
}

/**
 * 更新企业授权信息
 * @param {} parameter 
 * @returns 
 */
export function updateAuthorizationDocument (parameter) {
  return request({
    url: '/e-find-company/company/updateAuthorizationDocument',
    method: 'post',
    data: parameter
  })
}

/**
 * 更新企业授权信息
 * @param {} parameter 
 * @returns 
 */
export function updateSwitchPassword (parameter) {
  return request({
    url: '/e-find-company/company/updateSwitchPassword',
    method: 'post',
    data: parameter
  })
}

/**
 * 获取权证权利人信息
 * @param {} parameter 
 * @returns 
 */
export function getObligeeDetail () {
  return request({
    url: '/e-find-company/company/getObligeeDetail',
    method: 'get',
  })
}
